import { Component, Input, Output, EventEmitter, HostListener, forwardRef } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

const UI_SWITCH_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BfxToogleComponent),
  multi: true,
};

@Component({
  selector: "bfx-toggle",
  templateUrl: `./html/bfx-toggle.html`,
  providers: [UI_SWITCH_CONTROL_VALUE_ACCESSOR],
  standalone: false,
})
export class BfxToogleComponent implements ControlValueAccessor {
  private onTouchedCallback = (v: any) => {};
  private onChangeCallback = (v: any) => {};

  private _checked: boolean;
  private _disabled: boolean;
  private _reverse: boolean;
  private _switchHovered: boolean = false;

  @Input() set checked(v: boolean) {
    this._checked = v !== false;
  }

  get checked() {
    return this._checked;
  }

  @Input() set disabled(v: boolean) {
    this._disabled = v !== false;
  }

  get disabled() {
    return this._disabled;
  }

  @Input() set reverse(v: boolean) {
    this._reverse = v !== false;
  }

  get reverse() {
    return this._reverse;
  }

  @Input() size: string = "small";

  @Input() bold: boolean = true;

  @Output() change = new EventEmitter<boolean>();
  // @Input() color: string = 'rgb(100, 189, 99)';
  // @Input() switchOffColor: string = '#BDC4CE';
  // @Input() switchColor: string = '#379340';
  // defaultBgColor: string = '#8A97AA';
  // defaultBoColor: string = '#8A97AA';
  // switchHoveredBackground: string = "#000000";

  // getColor(flag?) {
  //   if (flag === 'borderColor') return this.defaultBoColor;
  //   if (flag === 'switchColor') {
  //     if(this._switchHovered) return this.switchHoveredBackground;
  //     if (this.reverse) return !this.checked ? this.switchColor : this.switchOffColor || this.switchColor;
  //     return this.checked ? this.switchColor : this.switchOffColor || this.switchColor;
  //   }
  //   if (this.reverse)  return !this.checked ? this.color : this.defaultBgColor;
  //   return this.checked ? this.color : this.defaultBgColor;
  // }

  /**
   * Works on desktop
   */
  @HostListener("click")
  onToggle() {
    if (this.disabled) return;
    this.checked = !this.checked;
    this.change.emit(this.checked);
    this.onChangeCallback(this.checked);
    this.onTouchedCallback(this.checked);
  }

  writeValue(obj: any): void {
    if (obj !== this.checked) {
      this.checked = !!obj;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  // public setSwitchHover(value: boolean){
  //   this._switchHovered = value;
  // }
}
